export function sortBadgeTemplatesByOrder(t1, t2) {
    return t1.columns.order - t2.columns.order;
}
